import { defaultDataSchemaContext } from './DataSchemaContext';
export const defaults = {
    context: defaultDataSchemaContext,
};
